import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { HeartIcon, PlayIcon } from 'lucide-react';
import { TrackTable } from '../components/TrackTable';
import { HeaderStage } from '../components/HeaderStage';
import { useLibrary } from '../contexts/LibraryContext';
import { usePlayer } from '../contexts/PlayerContext';
import { usePageMeta } from '../hooks/usePageMeta';
export function Favorites() {
  const {
    favorites
  } = useLibrary();
  const {
    play
  } = usePlayer();
  usePageMeta({
    title: favorites.length ? `Favourites · ${favorites.length} saved tracks` : 'Favourites',
    description: 'Every track you have hearted on Noctuzan, saved in this browser — real 30-second previews, ready to play end to end.',
    image: favorites[0]?.artwork,
    path: '/favorites'
  });
  return <div className="relative px-5 pb-16 pt-8 sm:px-8 lg:px-12" data-id="element-266" data-mp="1kaakidwgzklk">
      <HeaderStage artwork={favorites[0]?.artwork} data-id="element-267" data-mp="1p2c3eio589kk" />

      <motion.header initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.28,
      ease: [0.23, 1, 0.32, 1]
    }} className="relative z-10 flex flex-col gap-6 border-b border-ink-line pb-10 sm:flex-row sm:items-end sm:justify-between" data-id="element-268" data-mp="1p3vja85w0ilt">
        <div data-id="element-269" data-mp="ivz3c6v2yfe2">
          <p className="flex items-center gap-2 text-sm text-muted" data-id="element-270" data-mp="e35xtgrsf30x">
            <HeartIcon className="h-4 w-4 fill-iris-soft text-iris-soft" aria-hidden="true" data-id="element-271" data-mp="e1ut9eqipr8r" />
            Saved on this device
          </p>
          <h1 className="mt-3 font-display text-5xl leading-tight text-cream" data-id="element-272" data-mp="mvpz6ozgrlpg">Favourites</h1>
          <p className="mt-3 text-sm text-muted" data-id="element-273" data-mp="11sqetu4drq7k">
            {favorites.length} {favorites.length === 1 ? 'track' : 'tracks'} kept for later.
          </p>
        </div>
        {favorites.length > 0 && <button type="button" onClick={() => play(favorites, 0)} className="flex w-fit items-center gap-2 rounded-full bg-gold px-5 py-2.5 text-sm font-medium text-ink-base transition-transform duration-150 ease-night hover:scale-[1.02] focus:outline-none focus-visible:ring-2 focus-visible:ring-iris-soft focus-visible:ring-offset-2 focus-visible:ring-offset-ink-base" data-id="element-274" data-mp="33jts6r5nnivt">
            <PlayIcon className="h-4 w-4" aria-hidden="true" data-id="element-275" data-mp="146pspksfszs" />
            Play all
          </button>}
      </motion.header>

      {favorites.length === 0 ? <div className="relative z-10 mt-12 max-w-md" data-id="element-276" data-mp="b2m7y31u7rx5">
          <h2 className="font-display text-2xl italic text-gold" data-id="element-277" data-mp="b24e1d2ndpse">Nothing saved yet</h2>
          <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-278" data-mp="f2wouar642qs">
            Tap the heart beside any track and it lands here. Favourites live in this browser&apos;s local storage,
            so they survive a refresh.
          </p>
          <Link to="/search" className="mt-6 inline-block rounded-full border border-ink-line px-5 py-2.5 text-sm text-cream transition-colors duration-150 ease-night hover:border-gold/60 hover:text-gold focus:outline-none focus-visible:ring-2 focus-visible:ring-iris-soft" data-id="element-279" data-mp="ow58vvqhasnh">
            Go find something
          </Link>
        </div> : <div className="relative z-10 mt-8 overflow-x-auto scroll-thin" data-id="element-280" data-mp="2e9uz9xfh7gcm">
          <TrackTable tracks={favorites} data-id="element-281" data-mp="29d4jzcbhwos9" />
        </div>}
    </div>;
}